import type { SiteRagReport } from '../../types/siteRag';

/** A revision marker prevents legacy read-time content repair. An invalid
 * marker still remains untouched and fails the existing source validator. */
export function isImmutableReportReadSource(report: Partial<SiteRagReport>): boolean {
  return Boolean(report.reportRevision);
}

/** Presentation cleanup must never become authority for an immutable request,
 * eligibility check or source receipt. Legacy readers retain their projection. */
export function sourceForReportActions(source: SiteRagReport, presentation: SiteRagReport): SiteRagReport {
  return isImmutableReportReadSource(source) ? source : presentation;
}
